import React, { useEffect, useState } from "react";
import UserDashboard from "../../../assets/dashboard/user-dashboard.svg";
import ServiceDashboard from "../../../assets/dashboard/service-dashboard.svg";
import SubscriptionDashboard from "../../../assets/dashboard/subscription-dashboard.svg";
import CancellationRateDashboard from "../../../assets/dashboard/cancellation_rate.svg";
import TotalRevenueDashboard from "../../../assets/dashboard/total_revenue.svg";
import ConversionRateDashboard from "../../../assets/dashboard/conversion_rate.png";
import Low from "../../../assets/dashboard/low.png";
import High from "../../../assets/dashboard/high.png";
import { GetDashboardWidgetData } from "../../../utils/api";
import { message } from "antd";
import { constructParams } from "./constructParams";
import { convertToViewableAmount } from "../../../utils/helper";

const Widgets = ({ selectedOption, startDate, endDate }) => {
  const [dashboardData, setDashboardData] = useState({});
  const [loading, setLoading] = useState(true);

  const fetch = async (params) => {
    try {
      setLoading(true);
      const queryParams = new URLSearchParams(params).toString();
      const response = await GetDashboardWidgetData(queryParams);
      setDashboardData(response?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error(error || "Unknown error occured. Please try again later.");
    }
  };

  useEffect(() => {
    const params = constructParams(selectedOption, startDate, endDate);
    fetch(params);
  }, [selectedOption, startDate, endDate]);

  if (loading) {
    return (
      <div className="w-full flex-wrap flex flex-col sm:flex-row items-center gap-5 leading-4">
        {[...Array(6)].map((_, index) => (
          <div
            key={index}
            className="bg-black-300 animate-pulse w-full flex-1 flex items-center gap-x-2 px-3 py-3 rounded-2xl h-[74px]"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="w-full flex flex-wrap flex-col sm:flex-row items-center gap-5 leading-4">
      <div className="w-full flex-1 flex items-center gap-x-2 bg-[#e0edff] px-3 py-3 rounded-2xl h-[74px]">
        <img className="w-10 h-10" src={UserDashboard} alt="user-icon" />
        <div className="flex flex-col items-start">
          <span className="font-bold pt-0.5 text-[#222222]">
            {dashboardData?.clients}
          </span>
          <span className="text-[11px] 2xl:text-xs font-medium leading-3 text-[#5b5f64]">
            Clients
          </span>
          {dashboardData?.clientUpdatePercentage !== 0 && (
            <div className="flex items-center gap-x-0.5">
              <img
                className="w-3 h-3 flex-shrink-0 object-contain"
                src={dashboardData?.clientUpdatePercentage > 0 ? High : Low}
                alt={dashboardData?.clientUpdatePercentage > 0 ? "Up" : "Down"}
              />
              <span className="text-[11px] 2xl:text-xs font-medium text-[#5b5f64]">
                {Math.abs(dashboardData?.clientUpdatePercentage)}%
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="w-full flex-1 flex items-center gap-x-2 bg-[#fff5d7] px-3 py-3 rounded-2xl h-[74px]">
        <img className="w-10 h-10" src={ServiceDashboard} alt="user-icon" />
        <div className="flex flex-col items-start">
          <span className="font-bold pt-0.5 text-[#222222]">
            {dashboardData?.providers}
          </span>
          <span className="text-[11px] 2xl:text-xs font-medium leading-3 text-[#5b5f64]">
            Service Providers
          </span>
          {dashboardData?.providerUpdatePercentage !== 0 && (
            <div className="flex items-center gap-x-0.5">
              <img
                className="w-3 h-3 flex-shrink-0 object-contain"
                src={dashboardData?.providerUpdatePercentage > 0 ? High : Low}
                alt={
                  dashboardData?.providerUpdatePercentage > 0 ? "Up" : "Down"
                }
              />
              <span className="text-[11px] 2xl:text-xs font-medium text-[#5b5f64]">
                {Math.abs(dashboardData?.providerUpdatePercentage)}%
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="w-full flex-1 flex items-center gap-x-2 bg-[#e8f7eb] px-3 py-3 rounded-2xl h-[74px]">
        <img
          className="w-10 h-10"
          src={SubscriptionDashboard}
          alt="subscription-icon"
        />
        <div className="flex flex-col items-start">
          <span className="font-bold pt-0.5 text-[#222222]">
            {dashboardData?.signUps}
          </span>
          <span className="text-[11px] 2xl:text-xs font-medium leading-3 text-[#5b5f64]">
            Sign Ups
          </span>
        </div>
      </div>
      {/* <div className="w-full flex-1 flex items-center gap-x-2 bg-[#f1edeb] px-3 py-3 rounded-2xl">
        <img
          className="w-10 h-10"
          src={CalenderDashboard}
          alt="calender-icon"
        />
        <div className="flex flex-col items-start">
          <span className="font-bold pt-0.5 text-[#222222]">
            {dashboardData?.bookNowClicksCount}
          </span>
          <span className="text-[11px] 2xl:text-xs font-medium text-[#5b5f64]">
            Book Now Clicks
          </span>
        </div>
      </div> */}
      <div className="w-full flex-1 flex items-center gap-x-2 bg-[#F1EDEB] px-3 py-3 rounded-2xl h-[74px]">
        <img
          className="w-10 h-10"
          src={CancellationRateDashboard}
          alt="cancellation-icon"
        />
        <div className="flex flex-col items-start">
          <span className="font-bold pt-0.5 text-[#222222]">
            {dashboardData?.cancellationRatePercentage}%
          </span>
          <span className="text-[11px] 2xl:text-xs font-medium leading-3 text-[#5b5f64]">
            Cancellation Rate
          </span>
        </div>
      </div>

      <div className="w-full flex-1 flex items-center gap-x-2 bg-[#C8E6DF] px-3 py-3 rounded-2xl h-[74px]">
        <img
          className="w-10 h-10"
          src={TotalRevenueDashboard}
          alt="revenue-icon"
        />
        <div className="flex flex-col items-start">
          <span className="font-bold pt-0.5 text-[#222222]">
            {convertToViewableAmount(dashboardData?.totalRevenue)}
          </span>
          <span className="text-[11px] 2xl:text-xs font-medium leading-3 text-[#5b5f64]">
            Total Revenue
          </span>
          {dashboardData?.previousRevenuePercentage !== 0 && (
            <div className="flex items-center gap-x-0.5">
              <img
                className="w-3 h-3 flex-shrink-0 object-contain"
                src={dashboardData?.previousRevenuePercentage > 0 ? High : Low}
                alt={
                  dashboardData?.previousRevenuePercentage > 0 ? "Up" : "Down"
                }
              />
              <span className="text-[11px] 2xl:text-xs font-medium text-[#5b5f64]">
                {Math.abs(dashboardData?.previousRevenuePercentage)}%
              </span>
            </div>
          )}
        </div>
      </div>

      <div className="w-full flex-1 flex items-center gap-x-2 bg-[#DBE6EF] px-3 py-3 rounded-2xl h-[74px]">
        <img
          className="w-10 h-10"
          src={ConversionRateDashboard}
          alt="conversion-icon"
        />
        <div className="flex flex-col items-start">
          <span className="font-bold pt-0.5 text-[#222222]">
            {dashboardData?.conversionRate}%
          </span>
          <span className="text-[11px] 2xl:text-xs font-medium leading-3 text-[#5b5f64]">
            Conversion Rate
          </span>
        </div>
      </div>
    </div>
  );
};

export default Widgets;
